import axios from "@/services/axios.config";
import type { CreditIssuanceListWithPagination } from "@/types/creditTracking";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

const fetchCreditIssuanceListForRegistry = async (
	limit: number,
	offset: number,
): Promise<CreditIssuanceListWithPagination> =>
	axios
		.get<APIResponse<CreditIssuanceListWithPagination>>("/credit/issue/list/public", {
			params: { limit, offset },
		})
		.then((res) => res.data.data ?? { limit: String(limit), offset: String(offset), count: 0, data: [] })
		.catch((err) => Promise.reject(err.response?.data as APIResponse));

export default function useGetCreditIssuanceListForRegistry(limit: number, offset: number) {
	return useQuery({
		queryKey: ["getCreditIssuanceListForRegistry", limit, offset],
		queryFn: () => fetchCreditIssuanceListForRegistry(limit, offset),
		onError: (err: APIResponse) => {
			if (![400, 403, 404].includes(err.httpStatus)) {
				toastOnError(err);
			}
		},
	});
}
